import {
  Icon,
  IconButton,
  Input,
  InputGroup,
  InputRightElement,
} from "@chakra-ui/react";
import { forwardRef, useCallback, useState } from "react";
import { IoEyeOffOutline, IoEyeOutline } from "react-icons/io5";
import { useIntl } from "react-intl";

const InputPassword = forwardRef(
  /**
   * @typedef {object} Props
   *
   * @param {Props & import("@chakra-ui/react").InputProps} props
   */
  function InputPassword({ ...otherProps }, ref) {
    const [isVisible, setIsVisible] = useState(false);

    const intl = useIntl();

    const toggle = useCallback(() => {
      setIsVisible((isVisible) => !isVisible);
    }, []);

    return (
      <InputGroup>
        <Input
          {...otherProps}
          ref={ref}
          type={isVisible ? "text" : "password"}
        />

        <InputRightElement zIndex="initial">
          <IconButton
            icon={<Icon as={isVisible ? IoEyeOffOutline : IoEyeOutline} />}
            onClick={toggle}
            colorScheme="brandPrimary"
            size="sm"
            aria-label={intl.formatMessage({
              defaultMessage: "Afficher / Masquer le mot de passe",
            })}
          />
        </InputRightElement>
      </InputGroup>
    );
  },
);

export default InputPassword;
